export const TopicsCardPortalElementId = "search-result-list-topics-card";
